const map = {
  'automator.log': 'automator',
  'logcat.log': 'logcat',
  'selenium-server.log': 'seleniumserver',
};

const knownExtentions = ['js', 'json'];

const findLogType = (fileName) => {
  const hashmapResult = map[fileName];

  if (hashmapResult) {
    return hashmapResult;
  }

  const fileNameByDot = fileName.split('.');
  const extension = fileNameByDot[fileNameByDot.length - 1];

  return knownExtentions.find((known) => known === extension) || 'markup';
};

export default findLogType;
